module.exports = __webpack_public_path__ + "static/media/About-us-300x200.a57a5cb2.jpg";